import { render, staticRenderFns } from "./AuthSidebar.vue?vue&type=template&id=a083723a&"
import script from "./AuthSidebar.vue?vue&type=script&lang=js&"
export * from "./AuthSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports